import React from 'react';
import {withStyles} from '@material-ui/core';
import Typography from '@material-ui/core/Typography/Typography';
import Badge from '@material-ui/core/Badge';
import Chip from '@material-ui/core/Chip';

class ProjectStatusText extends React.Component {

    render() {
        const {status, classes} = this.props;

        const style = {};
        if ( status && status.color) {
            style.backgroundColor = status.color;
        }

        if ( status === null || status.name === null ) {
            return null;
        }

        return (
            <Typography component={"span"} className={classes.span} >
                <Chip label={status && status.name} className={classes.chip} style={style} />
            </Typography>
        );
    }
}

const styles = theme => ({
    span: {
        display: 'inline-block',
    },
    chip: {
        height: 24,
        fontSize: 12,
    },

});

export default withStyles(styles)(ProjectStatusText);
